export enum AIResponseType {
  SUMMARY = 'summary',
  PERSONAS = 'personas'
}

export interface AIMetadata {
  total_count: number;

  analyzed_count: number;
  analyzed_fields: Array<string>;

  word_count: number;
  count_is_exact: boolean;

  est_total_words: number;
  est_total_positive_count: number;
  est_total_negative_count: number;

  min_timestamp: string;
  max_timestamp: string;

  positive_count: number;
  negative_count: number;
  positivity: number;

  timeline: Array<number>;
  timeline_timestamps: Array<string>;
  timeline_distribution: Array<number>;

  query_prompt?: string;

  token: string;
}

export interface AIOutput {
  complete?: boolean;

  title?: string;
  introduction?: string;
  conclusion?: string;
}

export interface AISummaryOutput extends AIOutput {
  answer?: string;
  narratives?: Array<AISummaryNarrative>;
}

export interface AIPersonasOutput extends AIOutput {
  personas?: Array<AISummaryPersona>;
}

export interface AISummaryNarrative {
  title?: string;
  key_terms?: Array<AINarrativeTerm>;
  description?: string;
  positivity?: number;
  distribution?: number;
  language?: string|null;
  peak_date?: string|null;
  examples?: Array<string>;
  query?: object;
}

export interface AINarrativeTerm {
  label: string;
  query: object;
  relevance?: number;
  count?: number;
  appearances?: number;
  distribution?: number;
  est_total_count?: number;
  est_total_appearances?: number;
  positive_count?: number;
  negative_count?: number;
  est_total_positive_count?: number;
  est_total_negative_count?: number;
  positivity?: number;
  sentimental?: number;
  language?: string;
}

export interface AISummaryGender {
  f?: number;
  m?: number;
  n?: number;
}

export interface AISummaryPersona {
  title?: string;
  key_terms?: Array<AINarrativeTerm>;
  description?: string;
  positivity?: number;
  distribution?: number;
  gender?: AISummaryGender;
  examples?: Array<string>;
  query?: object;
}

export interface AIError {
  error: string;
}

export interface AIAsyncResponse {
  complete?: boolean;
  error?: string;
  output?: AIOutput;
}

export function getAIResponseByType(type: AIResponseType, response: AIOutput): AISummaryOutput | AIPersonasOutput {
  switch (type) {
    case AIResponseType.SUMMARY:
      return response as AISummaryOutput;
    case AIResponseType.PERSONAS:
      return response as AIPersonasOutput;
  }
}